namespace $.$$ {
	export class $shm_ba_mention_stats_task_list extends $.$shm_ba_mention_stats_task_list {
		private task_add_drafts = new WeakMap< Event, { title: string, sort: number } >()

		filter_text( value: string ) {
			return String( value ).replaceAll( '\\', '\\\\' ).replaceAll( '"', '\\"' )
		}

		tasks() {
			const user = this.$.$shm_ba_pb.user_id()
			if( !user ) return [] as readonly $shm_ba_pb_file_record[]
			return this.$.$shm_ba_pb.records_page_realtime_live(
				`mention_stats_tasks\nuser = "${ this.filter_text( user ) }"\n-sort\n1\n200`,
				`mention_stats_tasks/user:${ user }:list`,
				record => String( record.user || '' ) === user,
			)
		}

		task_rows() {
			const tasks = this.tasks_filtered()
			return tasks.length ? tasks.map( task => this.Task_link( task.id ) ) : [ this.Empty() ]
		}

		search_showed() {
			return this.tasks().length >= 10
		}

		tasks_filtered() {
			const tasks = this.tasks()
			if( !this.search_showed() ) return tasks

			const filter = this.filter().trim().toLowerCase()
			if( !filter ) return tasks

			return tasks.filter( task => String( task.title || '' ).toLowerCase().includes( filter ) )
		}
		task_title( id: string ) { return String( this.tasks().find( task => task.id === id )?.title || 'Задача' ) }
		task_current( id: string ) { return this.task_id() === id }
		task_arg( id: string ) {
			const mode = String( this.$.$mol_state_local.value( `hitalama_mentionstat_task_mode:${ id }` ) || 'edit' )
			return { section: 'mention_stats', mention_stats_task: id, mention_stats_mode: mode }
		}
		task_uri( id: string ) {
			return new this.$.$mol_state_arg( this.Task_link( id ).state_key() ).link( this.task_arg( id ) )
		}

		@ $mol_action
		task_add( next?: Event ) {
			if( next === undefined ) return null

			let draft = this.task_add_drafts.get( next )
			if( !draft ) {
				const tasks = this.$.$mol_wire_probe( ()=> this.tasks() ) ?? []
				const titles = new Set( tasks.map( task => String( task.title ) ) )
				let index = 1
				while( titles.has( `Задача ${ index }` ) ) ++index
				draft = { title: `Задача ${ index }`, sort: Date.now() }
				this.task_add_drafts.set( next, draft )
			}

			const record = this.$.$shm_ba_pb.create_record( 'mention_stats_tasks', {
				user: this.$.$shm_ba_pb.user_id(), ... draft, settings: {}, status: 'draft',
			} )
			this.$.$mol_state_local.value( `hitalama_mentionstat_task_mode:${ record.id }`, 'edit' )
			this.$.$mol_state_arg.value( 'mention_stats_mode', null )
			this.task_id( record.id )
			this.task_add_drafts.delete( next )
			return next
		}
	}
}
